/* eslint-disable jsx-a11y/alt-text */
import { Grid, Box, Typography, Divider } from '@material-ui/core';
import React from 'react';
import { simpleDateFormatter2, moneyFormatEmpty } from '../Shared/colorFormat';

const printcolor = '#333';

export class SupplierContractPrint extends React.PureComponent<any, any> {
  renderHeader = (company: any) => (
    <Grid item xs={12}>
      <img
        src={company?.header}
        alt={company?.name}
        height="auto"
        width="100%"
        style={{
          objectFit: 'contain',
        }}
      />
    </Grid>
  );

  renderFooter = (company: any) => (
    <Grid item xs={12}>
      <img
        src={company?.footer}
        alt={company?.name}
        height={50}
        width="100%"
        style={{
          objectFit: 'contain',
          alignSelf: 'flex-start',
        }}
      />
    </Grid>
  );

  renderTitle = (data: any, isRTL: any) => {
    return (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 20,
          marginTop: 20,
        }}
      >
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: 22,
            color: printcolor,
            textDecoration: 'underline',
          }}
        >
          {isRTL ? 'عقد مورد' : 'Supplier Contract'}
        </Typography>
      </Box>
    );
  };

  renderContractNo = (data: any, isRTL: any) => {
    return (
      <Box
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 10,
        }}
      >
        <Typography style={{ fontSize: 12, color: printcolor }}>
          {isRTL ? 'رقم العقد:' : 'Contract No:'} {data?.docNo}
        </Typography>
        <Typography style={{ fontSize: 12, color: printcolor }}>
          {isRTL ? 'التاريخ:' : 'Date:'} {simpleDateFormatter2(data?.time)}
        </Typography>
      </Box>
    );
  };

  renderPartyBox = (title: any, data: any, isRTL: any) => {
    return (
      <Box
        border={1}
        borderColor="grey.400"
        p={2}
        mb={2}
        style={{ borderRadius: 5 }}
      >
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: 14,
            color: printcolor,
            marginBottom: 10,
            textDecoration: 'underline',
          }}
        >
          {title}
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 11, color: printcolor }}>
              {isRTL ? 'الاسم:' : 'Name:'} {isRTL ? data?.nameAr : data?.name}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography style={{ fontSize: 11, color: printcolor }}>
              {isRTL ? 'الهاتف:' : 'Phone:'} {data?.phone}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography style={{ fontSize: 11, color: printcolor }}>
              {isRTL ? 'العنوان:' : 'Address:'} {data?.address}
            </Typography>
          </Grid>
          {data?.email && (
            <Grid item xs={12}>
              <Typography style={{ fontSize: 11, color: printcolor }}>
                {isRTL ? 'البريد الإلكتروني:' : 'Email:'} {data?.email}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Box>
    );
  };

  renderContractTerms = (data: any, isRTL: any) => {
    return (
      <Box mb={2}>
        <Typography
          style={{
            fontWeight: 'bold',
            fontSize: 14,
            color: printcolor,
            marginBottom: 10,
            textDecoration: 'underline',
          }}
        >
          {isRTL ? 'شروط العقد' : 'Contract Terms'}
        </Typography>
        <Box
          border={1}
          borderColor="grey.400"
          p={2}
          style={{ borderRadius: 5, minHeight: 150 }}
        >
          <Typography
            style={{
              fontSize: 12,
              color: printcolor,
              whiteSpace: 'pre-wrap',
              lineHeight: 1.8,
            }}
          >
            {data?.terms || data?.desc}
          </Typography>
        </Box>
      </Box>
    );
  };

  renderContractDetails = (data: any, isRTL: any) => {
    return (
      <Box mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box
              border={1}
              borderColor="grey.400"
              p={1}
              style={{ borderRadius: 5 }}
            >
              <Typography style={{ fontSize: 11, color: printcolor }}>
                {isRTL ? 'تاريخ البداية:' : 'Start Date:'}{' '}
                {simpleDateFormatter2(data?.startDate)}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              border={1}
              borderColor="grey.400"
              p={1}
              style={{ borderRadius: 5 }}
            >
              <Typography style={{ fontSize: 11, color: printcolor }}>
                {isRTL ? 'تاريخ النهاية:' : 'End Date:'}{' '}
                {simpleDateFormatter2(data?.endDate)}
              </Typography>
            </Box>
          </Grid>
          {data?.amount && (
            <Grid item xs={12}>
              <Box
                border={1}
                borderColor="grey.400"
                p={1}
                style={{ borderRadius: 5 }}
              >
                <Typography style={{ fontSize: 11, color: printcolor }}>
                  {isRTL ? 'قيمة العقد:' : 'Contract Value:'}{' '}
                  {moneyFormatEmpty(data?.amount)}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    );
  };

  renderSignatures = (isRTL: any, company: any, supplier: any) => {
    return (
      <Box mt={4}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box
              border={1}
              borderColor="grey.400"
              p={2}
              style={{ borderRadius: 5, minHeight: 100 }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: 12,
                  color: printcolor,
                  textAlign: 'center',
                  marginBottom: 10,
                }}
              >
                {isRTL ? 'الطرف الأول (الشركة)' : 'First Party (Company)'}
              </Typography>
              <Typography
                style={{ fontSize: 11, color: printcolor, textAlign: 'center' }}
              >
                {isRTL ? company?.nameAr : company?.name}
              </Typography>
              <Box mt={4}>
                <Typography
                  style={{
                    fontSize: 10,
                    color: printcolor,
                    textAlign: 'center',
                  }}
                >
                  {isRTL
                    ? 'التوقيع: _______________'
                    : 'Signature: _______________'}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box
              border={1}
              borderColor="grey.400"
              p={2}
              style={{ borderRadius: 5, minHeight: 100 }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: 12,
                  color: printcolor,
                  textAlign: 'center',
                  marginBottom: 10,
                }}
              >
                {isRTL ? 'الطرف الثاني (المورد)' : 'Second Party (Supplier)'}
              </Typography>
              <Typography
                style={{ fontSize: 11, color: printcolor, textAlign: 'center' }}
              >
                {isRTL ? supplier?.nameAr : supplier?.name}
              </Typography>
              <Box mt={4}>
                <Typography
                  style={{
                    fontSize: 10,
                    color: printcolor,
                    textAlign: 'center',
                  }}
                >
                  {isRTL
                    ? 'التوقيع: _______________'
                    : 'Signature: _______________'}
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Box mt={2} style={{ textAlign: 'center' }}>
          <Typography style={{ fontSize: 10, color: '#666' }}>
            {isRTL
              ? 'تم تحرير هذا العقد من نسختين، لكل طرف نسخة للعمل بموجبها'
              : 'This contract was made in two copies, each party holds one copy'}
          </Typography>
        </Box>
      </Box>
    );
  };

  render() {
    const data = this.props?.printData;
    const isRTL = data?.isRTL;
    const company = this.props?.company;
    const supplier = data?.supplier || data?.suppvalue;

    return (
      <Box style={{ direction: isRTL ? 'rtl' : 'ltr' }}>
        <Grid container spacing={0}>
          {this.renderHeader(company)}
          <Grid item xs={12}>
            <Box ml={4} mr={4}>
              {this.renderTitle(data, isRTL)}
              {this.renderContractNo(data, isRTL)}
              <Divider style={{ marginBottom: 15 }} />

              {this.renderPartyBox(
                isRTL ? 'الطرف الأول (الشركة)' : 'First Party (Company)',
                {
                  name: company?.name,
                  nameAr: company?.nameAr,
                  phone: company?.tel,
                  address: company?.address,
                  email: company?.email,
                },
                isRTL,
              )}

              {this.renderPartyBox(
                isRTL ? 'الطرف الثاني (المورد)' : 'Second Party (Supplier)',
                supplier,
                isRTL,
              )}

              {this.renderContractDetails(data, isRTL)}
              {this.renderContractTerms(data, isRTL)}
              {this.renderSignatures(isRTL, company, supplier)}
            </Box>
          </Grid>
          {this.renderFooter(company)}
        </Grid>
      </Box>
    );
  }
}

export default SupplierContractPrint;
